import { render, staticRenderFns } from "./dialogDrag.vue?vue&type=template&id=0a49efae&"
import script from "./dialogDrag.vue?vue&type=script&lang=js&"
export * from "./dialogDrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a49efae')) {
      api.createRecord('0a49efae', component.options)
    } else {
      api.reload('0a49efae', component.options)
    }
    module.hot.accept("./dialogDrag.vue?vue&type=template&id=0a49efae&", function () {
      api.rerender('0a49efae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/drag/dialogDrag.vue"
export default component.exports